import React from "react";
import { Table } from "react-bootstrap";
import { ActionMenu } from "../../../../components/Ads/ActionMenu/ActionMenu";
import { formatDate } from "../../../../utils/formatUtils";
import type { ClaimRequest } from "../../../../api/playerVault";
import "../../../Ads/Creatives/components/CreativeTable.css";

interface ClaimRequestsTableProps {
  requests: ClaimRequest[];
  onApprove: (request: ClaimRequest) => void;
  onReject: (request: ClaimRequest) => void;
}

function formatRelationshipType(raw: string): string {
  if (!raw) return "—";
  return raw
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" / ");
}

const ClaimRequestsTable: React.FC<ClaimRequestsTableProps> = ({
  requests,
  onApprove,
  onReject,
}) => {
  return (
    <div className="ads-table-wrapper">
      <Table responsive className="ads-table">
        <thead>
          <tr>
            <th>Request ID</th>
            <th>Player Vault ID</th>
            <th>Player Name</th>
            <th>Requested By</th>
            <th>Phone</th>
            <th>Relationship</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((req) => (
            <tr key={req.request_id}>
              <td>
                <span className="ads-table-id">{req.request_id}</span>
              </td>
              <td>{req.player_vault_id || "—"}</td>
              <td>{req.player_name || req.player_id || "—"}</td>
              <td>{req.requested_by_user_id}</td>
              <td>{req.requested_by_user_phone || "—"}</td>
              <td>{formatRelationshipType(req.relationship_type)}</td>
              <td>
                <span className={`ads-tag ads-tag--${req.status}`}>
                  {req.status.charAt(0).toUpperCase() + req.status.slice(1)}
                </span>
              </td>
              <td>{req.created_at ? formatDate(req.created_at) : "—"}</td>
              <td>{req.updated_at ? formatDate(req.updated_at) : "—"}</td>
              <td>
                {req.status === "rejected" ? (
                  <ActionMenu
                    ariaLabel={`Actions for request ${req.request_id}`}
                    items={[
                      {
                        key: "approve",
                        label: "Approve",
                        iconClassName: "ph-check-circle",
                        onSelect: () => onApprove(req),
                      },
                    ]}
                  />
                ) : req.status === "approved" ? (
                  <ActionMenu
                    ariaLabel={`Actions for request ${req.request_id}`}
                    items={[
                      {
                        key: "reject",
                        label: "Reject",
                        iconClassName: "ph-x-circle",
                        isDanger: true,
                        onSelect: () => onReject(req),
                      },
                    ]}
                  />
                ) : req.status === "pending" ? (
                  <ActionMenu
                    ariaLabel={`Actions for request ${req.request_id}`}
                    items={[
                      {
                        key: "approve",
                        label: "Approve",
                        iconClassName: "ph-check-circle",
                        onSelect: () => onApprove(req),
                      },
                      {
                        key: "reject",
                        label: "Reject",
                        iconClassName: "ph-x-circle",
                        isDanger: true,
                        onSelect: () => onReject(req),
                      },
                    ]}
                  />
                ) : (
                  <span className="ads-table-no-actions">—</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ClaimRequestsTable;
